import React from 'react';
import MuiTooltip, { type TooltipProps } from '@mui/material/Tooltip';
import classNames from 'classnames';

function Tooltip({
  light,
  classes,
  ...rest
}: TooltipProps & { light?: boolean }) {
  return (
    <MuiTooltip
      classes={{
        ...classes,
        tooltip: classNames(classes?.tooltip, { 'MuiTooltip-light': light }),
      }}
      {...rest}
    />
  );
}

export default Tooltip;
